import { BaseRouteService } from 'core/services';

class TaskCommentRouteService extends BaseRouteService {
    constructor() {
        super('task-comments');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityScheduleDateId,isRead,receiverUserId}', filter);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }
}

export default TaskCommentRouteService;